var React = require('react');

function Loading (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3z"}));
}

Loading.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Loading;

Loading.default = Loading;
